import { render, staticRenderFns } from "./SettingsIcon.vue?vue&type=template&id=1fbf3ba0&scoped=true&"
import script from "./SettingsIcon.vue?vue&type=script&lang=js&"
export * from "./SettingsIcon.vue?vue&type=script&lang=js&"
import style0 from "./SettingsIcon.vue?vue&type=style&index=0&id=1fbf3ba0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fbf3ba0",
  null
  
)

export default component.exports